import { render, staticRenderFns } from "./Autocomplete.vue?vue&type=template&id=8aafbcba&scoped=true&"
import script from "./Autocomplete.vue?vue&type=script&lang=js&"
export * from "./Autocomplete.vue?vue&type=script&lang=js&"
import style0 from "./Autocomplete.vue?vue&type=style&index=0&id=8aafbcba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8aafbcba",
  null
  
)

export default component.exports